import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';


/** MyMine Version2.0 AHSLv2SubLv1画面新規追加
* AHSLv2SubLv1 Page Content
*/
export const AHSLv2SubLv1 = () => {
  const LayerInfoPanel = (props) => {
    const { index } = props;
    return (
      <Grid item xs={12} md={12} lg={5}>
        {controlSettings.ImageList['imgLayerInfoHeaderIcon' + index] ?
          <Box sx={{
            padding: '10px',
            border: '2px solid #D4D4D4',
            borderRadius: '5px',
            height: '500px',
            overflowY: 'auto',
          }}>
            <Grid container>
              <Grid item xs={1.5}>
                <MyMImage
                  screenId={screenId}
                  filePath={controlSettings.ImageList['imgLayerInfoHeaderIcon' + index]}
                  alt='LayerInfoIcon'
                  height='auto'
                  width='100%'
                  display='block'
                />
              </Grid>
              <Grid item xs={10.5} sx={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '2px',

              }} >
                <MyMLabel sx={{ textAlign: 'left' }} >{controlSettings.LabelList['lblLayerInfoHeader' + index]}</MyMLabel>
              </Grid>
            </Grid>
            <MyMLabel sx={{ margin: '10px 0' }}>{controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text1']}</MyMLabel>

            {
              controlSettings.ImageList[`imgLayerInfoDescription${index}Image1`] ?
                <MyMImage
                  screenId={screenId}
                  filePath={controlSettings.ImageList[`imgLayerInfoDescription${index}Image1`]}
                  alt='LayerInfDescription1'
                  height='auto'
                  width='100%'
                  display='block'
                  style={{ margin: '10px 0' }}
                /> : null
            }
            {
              controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text2'] ?
                <MyMLabel sx={{ margin: '10px 0' }}>{controlSettings.LabelList['lblLayerInfoDescription' + index + 'Text2']}</MyMLabel> : null
            }
            {
              controlSettings.ImageList[`imgLayerInfoDescription${index}Image2`] ?
                <MyMImage
                  screenId={screenId}
                  filePath={controlSettings.ImageList[`imgLayerInfoDescription${index}Image2`]}
                  alt='LayerInfDescription2'
                  height='auto'
                  width='100%'
                  display='block'
                  style={{ margin: '10px 0' }}
                /> : null
            }
          </Box>
          : null
        }
      </Grid >

    );

  }
  const screenId = 'MyM314';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    const endLoading = () => setIsLoading(false);

    apiRequest.requestJson('api/ahs/lv2-1', 'GET', endLoading, endLoading);
  }
    , [])

  if (isLoading)
    return <MyMProgress />

  return (
    <Box>
      <Box sx={{ paddingTop:'25px' }}>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblAhsLv2_1Title}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblAhsLv2_1Description}</MyMLabel>
      </Box>
    <Grid container className='mt-4'>
      <Grid item xs={1} />
      <Grid item xs={10} >
          <Grid container spacing={4}>
          <Grid item xs={12} md={12} lg={6.5} >
            <MyMImage
              screenId={screenId}
              filePath={controlSettings.ImageList.imgWhatIsAhs}
              alt='WhatIsAhs'
              height='auto'
              width='90%'
              display='block'
            />
          </Grid >
          <Grid item xs={12} md={12} lg={5.5} sx={{ marginTop: '35px' }} >
            <Box sx={{
              padding: '5px',
              height: '100%',
            }}>
              <MyMLabel>{controlSettings.LabelList.lblWhatIsAhs}</MyMLabel>
            </Box>
          </Grid >
        </Grid >
        <Grid container spacing={4} sx={{ marginTop: '100px', marginBottom: '150px' }}>
          <Grid item xs={12} md={12} lg={6.5} >
            <Box sx={{
              padding: '5px',
              height: '100%',
              marginRight: '10px'
            }}>
              <MyMLabel>{controlSettings.LabelList.lblTechInfoAhs}</MyMLabel>
            </Box>
          </Grid >
          <Grid item xs={12} md={12} lg={5.5} >
            <MyMImage
              screenId={screenId}
              filePath={controlSettings.ImageList.imgTechInfoAhs}
              alt='TechInfoAhs'
              height='auto'
              width='100%'
              display='block'
            />
          </Grid >
        </Grid >
        <Grid container spacing={5} sx={{ marginBottom: '50px', justifyContent:'center' }}>
          {[...Array(8)].map((_, i) => {
            return (
              <LayerInfoPanel
                index={i + 1}
                key={i}

              />
            );
          })}
        </Grid >
      </Grid >
      <Grid item xs={1} />

      </Grid >
    </Box>

  );
}

export default AHSLv2SubLv1;